export const SEARCH_STRATEGY = Object.freeze({
  FRONTEND: 'frontend',
  BACKEND: 'backend',
});
